import styled from 'styled-components';

import { PRIMARY } from 'constants/colors';

import { rSize } from 'components/utils';

export default styled.div`
  h2 {
    font-family: 'SourceSansPro-Bold', Arial, 'sans-serif';
    font-size: ${rSize(19)};
  }

  h2,
  h3,
  h4,
  p {
    margin-top: 0;
    margin-bottom: 10px;
  }

  .planunit-selector {
    margin-bottom: 20px;
  }

  .widgets {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .left-side {
    flex-basis: 50%;
    flex-grow: 1;
  }

  .right-side {
    flex-basis: 50%;
  }

  .open-requests {
    width: 100%;
    padding: ${rSize(24)};
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    place-self: flex-start;
    margin-bottom: ${rSize(20)};

    h2 {
      margin-bottom: ${rSize(20)};
    }

    .MuiTableContainer-root {
      th.MuiTableCell-root.MuiTableCell-head {
        box-shadow: 0 -1px 0 0 #d8d8d8 inset;
      }
      width: auto;

      .is-today {
        background-color: var(--mui-palette-warning-container);
      }
      .is-saturday:not(.is-today) {
        background-color: var(--mui-palette-grey-100);
      }
      .is-sunday:not(.is-today) {
        background-color: var(--mui-palette-grey-100);
      }

      th,
      td {
        padding: 0 ${rSize(10)};
        height: ${rSize(50)};
      }

      .MuiTableHead-root {
        th {
          height: ${rSize(59)};
        }
        .is-today {
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        }
        .is-saturday:not(.is-today) {
          border-top-left-radius: 16px;
        }

        .is-sunday:not(.is-today) {
          border-top-right-radius: 16px;
        }

        .is-today,
        .is-saturday:not(.is-today),
        .is-sunday:not(.is-today) {
          box-shadow:
            0 -1px 0 0 #d8d8d8 inset,
            0 0 0 10px #ffffff !important;
        }
      }

      .MuiTableBody-root .MuiTableRow-root:nth-of-type(2n + 1) {
        background-color: var(--mui-palette-grey-50);
      }

      .MuiTableBody-root .MuiTableRow-root:last-child {
        th,
        td {
          border-bottom: none;
        }
        .is-today {
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;
        }
        .is-saturday:not(.is-today) {
          border-bottom-left-radius: 16px;
        }

        .is-sunday:not(.is-today) {
          border-bottom-right-radius: 16px;
        }
      }

      .MuiChip-root {
        border: 0;
        width: ${rSize(30)};
        height: ${rSize(30)};

        .MuiChip-label {
          font-size: ${rSize(18)};
          text-overflow: unset;
          padding: 0;

          .icon-spinner {
            color: ${PRIMARY};
          }
        }
      }

      &:first-child {
        .MuiTableCell-body {
          width: ${rSize(220)};
        }

        button {
          text-align: left;
          display: inline-block;
          position: relative;

          &:hover {
            text-decoration: underline;
          }

          & + .icon-spinner {
            margin-left: 10px;
          }
        }
      }

      &:first-child {
        flex-grow: 1;
      }

      &:nth-child(2) {
        .MuiTableCell-root {
          width: ${rSize(40)};
        }
      }

      &:last-child {
        .MuiTableCell-root {
          width: ${rSize(40)};
        }
      }
    }
  }

  @media (max-width: 1100px) {
    .widgets {
      flex-direction: column;
    }
    .open-requests,
    .task-status {
      width: 100%;
    }
    .open-requests {
      margin-bottom: ${rSize(40)};
    }
  }
`;
